import { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import Input from '../ui/Input';
import Button from '../ui/Button';

export default function EmailReportModal({
  isOpen,
  onClose,
  reportTypeLabel,
  defaultRecipient = '',
  onSend,
}) {
  const [recipientEmail, setRecipientEmail] = useState(defaultRecipient);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setRecipientEmail(defaultRecipient || '');
  }, [isOpen, defaultRecipient]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recipientEmail.trim()) return;
    setIsSending(true);
    try {
      await onSend(recipientEmail.trim());
      onClose();
    } catch {
      // Parent shows toast; keep modal open so the user can retry or edit the address.
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Email Report"
      className="email-report-modal"
    >
      <p className="modal-subtitle">
        Send the generated PDF directly to a recipient.
      </p>
      <form onSubmit={handleSubmit}>
        <Input
          id="email-report-type"
          label="Report Type"
          type="text"
          value={reportTypeLabel}
          readOnly
        />
        <Input
          id="email-recipient"
          label="Recipient Email"
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          placeholder="name@example.com"
          required
        />
        <div className="form-actions">
          <Button type="button" onClick={onClose} disabled={isSending}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={isSending}>
            {isSending ? 'Sending…' : 'Send'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
